import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-show-terms',
  templateUrl: './show-terms.component.html',
  styleUrls: ['./show-terms.component.scss'],
})
export class ShowTermsComponent implements OnInit {
  @ViewChild('content')
  set content(element: ElementRef<HTMLDivElement>) {
    if (element) {
      setTimeout(() => {
        element.nativeElement.scrollTop = element.nativeElement.scrollHeight;
      }, 420);
      setTimeout(() => {
        element.nativeElement.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }, 550);
    }
  }

  constructor(public modalController: ModalController) {}

  ngOnInit() {}
}
